/**
 * サブヘッダー
 */
import { Component } from '@angular/core';
import { CommonLibService } from '@lib/services';
import { SupportComponent } from '@lib/components/support-class';

/**
 * サブヘッダー
 */
@Component({
  selector: 'asw-sample-sub-header',
  templateUrl: './sample-sub-header.component.html',
  providers: [],
})
export class SampleSubHeaderComponent extends SupportComponent {
  reload(): void {}
  init(): void {}
  destroy(): void {}
}
